import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MatPaginator, MatSort, MatTableDataSource, MAT_DIALOG_DATA } from '@angular/material';
import { DscTituloPaginator, iconVer, isNotEmpty, saveContent, strMatTablePaginator } from 'src/app/general/variables';
import { MovilSeguimiento } from 'src/app/models/MovilSeguimiento';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';

@Component({
  selector: 'app-modal-detalle-movil',
  templateUrl: './modal-detalle-movil.component.html',
  styleUrls: ['./modal-detalle-movil.component.css']
})
export class ModalDetalleMovilComponent implements OnInit {

  strNroRegistro = '';
  strDscEstado = '';
  strMatTablePaginator = strMatTablePaginator;
  listaSeguimiento: MovilSeguimiento[];
  dataSource: MatTableDataSource<MovilSeguimiento>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  // matTableColumnsDef = ["item","etapa","estado","resultado","acciones"];
  matTableColumnsDef = ['item', 'etapa', 'resultado', 'acciones'];
  // matTableColumnsEtiq = ["Ítem","Etapa","Estado actual","Resultado del análisis","Acciones"];
  matTableColumnsEtiq = ['Ítem', 'Etapa', 'Resultado del análisis', 'Acciones'];
  iconVer = iconVer;

  @ViewChild(NavModalComponent) navModalC: NavModalComponent;

  constructor(private dialogRef: MatDialogRef<ModalDetalleMovilComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {

    let listaSeg: MovilSeguimiento[] = [];

    listaSeg = this.data.listaSeguimiento;

    listaSeg.forEach(element => {

      element.strFlgOcultar = 'NO';

      if (element.strFlgDatosGen == 'SI') {

        this.strNroRegistro = element.strCodigo;
        this.strDscEstado = element.strDscEstado;

        element.strFlgOcultar = 'SI';



      }

      element.boolFlgVerAccion = (isNotEmpty(element.strBase64DocCOM));

    });

    this.listaSeguimiento = listaSeg.filter(x => x.strFlgOcultar == 'NO');

    this._resetMatTable();

    this.navModalC.setDatosNavModal2('Detalle');

  }

  _cerrarModal() {
    this.dialogRef.close();
  }

  _resetMatTable() {

    if (this.listaSeguimiento) {

      setTimeout(() => {

        this.dataSource = new MatTableDataSource(this.listaSeguimiento);

        if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; }

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      }, 1);

    }

  }

  _descargarDocCOM(strBase64: string) {

    saveContent(strBase64, 'DocComunicación.pdf');


  }

}
